import { render, staticRenderFns } from "./giftClassifyList.vue?vue&type=template&id=22047956&scoped=true&"
import script from "./giftClassifyList.vue?vue&type=script&lang=js&"
export * from "./giftClassifyList.vue?vue&type=script&lang=js&"
import style0 from "./giftClassifyList.vue?vue&type=style&index=0&id=22047956&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22047956",
  null
  
)

export default component.exports